type FormStop = { id?: string };

/** Form indexes in route order: existing stops by route number, new stops slotted in. */
export function formIndexesInRouteOrder(
  formStops: FormStop[],
  routeNumbersById: Map<string, number>
): number[] {
  const routeOrder: number[] = formStops
    .map((stop, formIndex) => ({ stop, formIndex }))
    .filter(({ stop }) => !!stop.id)
    .sort(
      (a, b) =>
        (routeNumbersById.get(a.stop.id as string) as number) -
          (routeNumbersById.get(b.stop.id as string) as number) ||
        a.formIndex - b.formIndex
    )
    .map(({ formIndex }) => formIndex);

  formStops.forEach((stop, formIndex) => {
    if (stop.id) return;
    const followingExistingIndex = formStops.findIndex(
      (other, otherIndex) => otherIndex > formIndex && !!other.id
    );
    if (followingExistingIndex === -1) {
      routeOrder.push(formIndex);
      return;
    }
    routeOrder.splice(routeOrder.indexOf(followingExistingIndex), 0, formIndex);
  });
  return routeOrder;
}
